import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Allows safe formatting tags while removing scripts and dangerous attributes
 * 
 * **Validates: Requirements 2, 24**
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'p', 'br', 'hr',
      'strong', 'em', 'u', 's', 'mark',
      'ul', 'ol', 'li',
      'a', 'img',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'blockquote', 'code', 'pre',
      'div', 'span',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'style'],
    ALLOW_DATA_ATTR: false,
  });
}

/**
 * Checks if user has scrolled to the bottom of a scrollable element
 * Includes 10px threshold to handle floating point precision
 * 
 * **Validates: Requirements 3, 17**
 */
export function checkScrolledToBottom(element: HTMLElement): boolean {
  const { scrollTop, scrollHeight, clientHeight } = element;
  return scrollTop + clientHeight >= scrollHeight - 10;
}

/**
 * Formats version number for display
 * 
 * **Validates: Requirements 17**
 */
export function formatVersion(versionNumber: number): string {
  return `Version ${versionNumber}`;
}

/**
 * Gets color for status badge based on Ant Design color scheme
 * 
 * **Validates: Requirements 24**
 */
export function getStatusColor(status: string): string {
  switch (status) {
    case 'PUBLISHED':
      return 'green';
    case 'DRAFT':
      return 'blue';
    case 'ARCHIVED':
      return 'default';
    default:
      return 'default';
  }
}
